function downloadYears() {
  /*return state.settings.invoices
      .reduce((years, invoice) => {
        const invoiceYear = invoice.date.getFullYear()
        if (years.indexOf(invoiceYear) === -1) {
          years.push(invoiceYear)
        }
        return years
      }, [])
      .sort((a, b) => {
        return b - a
      })*/

  return [2019]
}

function downloadsOfYear(state) {
  return state.settings.downloads
}

export default {
  downloadsOfYear,
  downloadYears,
}
